module.exports = __webpack_public_path__ + "0d510f2c53f119ecd3941e82c1d972b6.svg";